<template>
  <div>
    <span :class="data.orderSalaryT>data.orderSalaryP ? 'blue' : ''">{{ data.orderSalaryT }}</span>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {

    }
  },
}
</script>

<style scoped>
.blue {
  color: blue;
}
</style>
